import {
  ListControlTestProcedureVersionsRequest,
  ListControlTestProcedureVersionsResponse,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { ControlServicePromiseClient } from '@trustero/trustero-api-web/lib/model/control_grpc_web_pb'
import { NewGrpcResponse, GrpcResponse } from '../../hooks/types'
import { useSwrImmutableGrpc } from '../../useSwrImmutableGrpc'

export const useControlTestProcedureVersions = (
  controlId?: string,
  shouldFetch = true,
): GrpcResponse<ListControlTestProcedureVersionsResponse> => {
  const request = new ListControlTestProcedureVersionsRequest()
  if (controlId) {
    request.setControlId(controlId)
  }

  const { response } = useSwrImmutableGrpc(
    ControlServicePromiseClient.prototype.listControlTestProcedureVersions,
    request,
    !!controlId && shouldFetch,
  )

  return NewGrpcResponse(response)
}
